import React from 'react';
import { useSelector } from 'react-redux';

export default function RecordingControls({
  onStartRecording,
  onPauseRecording,
  onResumeRecording,
  onStopRecording,
  onCancelRecording,
}) {
  const isRecording = useSelector((state) => state.recording.isRecording);
  const isTimerRunning = useSelector((state) => state.recording.isTimerRunning);
  const isCameraRecordingPaused = useSelector((state) => state.recording.isCameraRecordingPaused);
  const isCameraEnabled = useSelector((state) => state.recording.isCameraEnabled);
  const isScreenEnabled = useSelector((state) => state.recording.isScreenEnabled);
  const isAudioEnabled = useSelector((state) => state.recording.isAudioEnabled);

  if (isTimerRunning || isRecording) {
    return (
      <>
        <button
          type="button"
          onClick={() => (isCameraRecordingPaused ? onResumeRecording() : onPauseRecording())}
          style={{
            height: 40,
            padding: '0 14px',
            borderRadius: 8,
            border: 0,
            background: '#374151',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          {isCameraRecordingPaused ? 'Resume Recording' : 'Pause Recording'}
        </button>
        <button
          type="button"
          onClick={onStopRecording}
          style={{
            height: 40,
            padding: '0 14px',
            borderRadius: 8,
            border: 0,
            background: '#F8585C',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Stop Recording
        </button>
      </>
    );
  }

  if (isCameraEnabled || isScreenEnabled || isAudioEnabled) {
    return (
      <>
        <button
          type="button"
          onClick={onStartRecording}
          style={{
            height: 40,
            padding: '0 14px',
            borderRadius: 8,
            border: 0,
            background: '#10B981',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Start Recording
        </button>
        <button
          type="button"
          onClick={onCancelRecording}
          style={{
            height: 40,
            padding: '0 14px',
            borderRadius: 8,
            border: 0,
            background: '#6B7280',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Cancel
        </button>
      </>
    );
  }

  return null;
}
